import { all, call, put, takeLatest } from 'redux-saga/effects';

import { UPDATE_SETTINGS, SWITCH_SUBSCRIPTION_REQUEST } from './actionTypes';
import {
  updateSettings,
  switchSubscriptionFailure,
  switchSubscriptionRequest,
  switchSubscriptionSuccess,
} from './actions';
import axios, { AxiosResponse } from 'axios';

const switchSubscription = async (id: number) =>
  await axios.post<ISubscription>(`/api/v1/subscriptions/${id}/switch`);

function* updateSettingsSaga(action: any): Generator {
  try {
    yield call(() => updateSettings(action.payload.data));
  } catch (e: unknown) {}
}

function* switchSubscriptionSaga(action: ReturnType<typeof switchSubscriptionRequest>) {
  try {
    const response: AxiosResponse<ISubscription> = yield call(() =>
      switchSubscription(action.payload.id),
    );

    yield put(
      switchSubscriptionSuccess({
        subscription: response.data,
      }),
    );
  } catch (e: unknown) {
    yield put(
      switchSubscriptionFailure({
        error: e instanceof Error ? e.message : 'Unknown error',
      }),
    );
  }
}

export function* settingsSaga() {
  yield all([
    takeLatest(UPDATE_SETTINGS, updateSettingsSaga),
    takeLatest(SWITCH_SUBSCRIPTION_REQUEST, switchSubscriptionSaga),
  ]);
}
